// extracted by mini-css-extract-plugin
export default {"fullscreen-enabled":"Fullscreen-module__fullscreen-enabled__1AyCC"};